// Static UK town/city -> { lat, lng } lookup so we can plot locations on the map
// without any runtime geocoding service. Keys are lowercased; lookup is forgiving.
// Extend freely as new locations appear.

const COORDS = {
  london: { lat: 51.5074, lng: -0.1278 },
  birmingham: { lat: 52.4862, lng: -1.8904 },
  manchester: { lat: 53.4808, lng: -2.2426 },
  leeds: { lat: 53.8008, lng: -1.5491 },
  liverpool: { lat: 53.4084, lng: -2.9916 },
  sheffield: { lat: 53.3811, lng: -1.4701 },
  bristol: { lat: 51.4545, lng: -2.5879 },
  newcastle: { lat: 54.9783, lng: -1.6178 },
  'newcastle upon tyne': { lat: 54.9783, lng: -1.6178 },
  nottingham: { lat: 52.9548, lng: -1.1581 },
  leicester: { lat: 52.6369, lng: -1.1398 },
  coventry: { lat: 52.4068, lng: -1.5197 },
  bradford: { lat: 53.7960, lng: -1.7594 },
  cardiff: { lat: 51.4816, lng: -3.1791 },
  swansea: { lat: 51.6214, lng: -3.9436 },
  belfast: { lat: 54.5973, lng: -5.9301 },
  glasgow: { lat: 55.8642, lng: -4.2518 },
  edinburgh: { lat: 55.9533, lng: -3.1883 },
  aberdeen: { lat: 57.1497, lng: -2.0943 },
  dundee: { lat: 56.4620, lng: -2.9707 },
  inverness: { lat: 57.4778, lng: -4.2247 },
  stirling: { lat: 56.1165, lng: -3.9369 },
  southampton: { lat: 50.9097, lng: -1.4044 },
  portsmouth: { lat: 50.8198, lng: -1.0880 },
  brighton: { lat: 50.8225, lng: -0.1372 },
  plymouth: { lat: 50.3755, lng: -4.1427 },
  exeter: { lat: 50.7184, lng: -3.5339 },
  bournemouth: { lat: 50.7192, lng: -1.8808 },
  reading: { lat: 51.4543, lng: -0.9781 },
  oxford: { lat: 51.7520, lng: -1.2577 },
  cambridge: { lat: 52.2053, lng: 0.1218 },
  norwich: { lat: 52.6309, lng: 1.2974 },
  ipswich: { lat: 52.0567, lng: 1.1482 },
  luton: { lat: 51.8787, lng: -0.4200 },
  milton: { lat: 52.0406, lng: -0.7594 },
  'milton keynes': { lat: 52.0406, lng: -0.7594 },
  northampton: { lat: 52.2405, lng: -0.9027 },
  peterborough: { lat: 52.5695, lng: -0.2405 },
  derby: { lat: 52.9226, lng: -1.4746 },
  stoke: { lat: 53.0027, lng: -2.1794 },
  'stoke-on-trent': { lat: 53.0027, lng: -2.1794 },
  wolverhampton: { lat: 52.5862, lng: -2.1288 },
  walsall: { lat: 52.5862, lng: -1.9829 },
  'west bromwich': { lat: 52.5187, lng: -1.9945 },
  solihull: { lat: 52.4118, lng: -1.7776 },
  telford: { lat: 52.6766, lng: -2.4453 },
  shrewsbury: { lat: 52.7069, lng: -2.7553 },
  worcester: { lat: 52.1920, lng: -2.2200 },
  gloucester: { lat: 51.8642, lng: -2.2380 },
  cheltenham: { lat: 51.8994, lng: -2.0783 },
  swindon: { lat: 51.5558, lng: -1.7797 },
  bath: { lat: 51.3811, lng: -2.3590 },
  preston: { lat: 53.7632, lng: -2.7031 },
  blackpool: { lat: 53.8175, lng: -3.0357 },
  blackburn: { lat: 53.7486, lng: -2.4829 },
  bolton: { lat: 53.5769, lng: -2.4282 },
  wigan: { lat: 53.5450, lng: -2.6318 },
  stockport: { lat: 53.4106, lng: -2.1575 },
  oldham: { lat: 53.5409, lng: -2.1114 },
  rochdale: { lat: 53.6097, lng: -2.1561 },
  warrington: { lat: 53.3900, lng: -2.5970 },
  chester: { lat: 53.1934, lng: -2.8931 },
  york: { lat: 53.9600, lng: -1.0873 },
  hull: { lat: 53.7676, lng: -0.3274 },
  'kingston upon hull': { lat: 53.7676, lng: -0.3274 },
  middlesbrough: { lat: 54.5742, lng: -1.2350 },
  sunderland: { lat: 54.9069, lng: -1.3838 },
  durham: { lat: 54.7761, lng: -1.5733 },
  doncaster: { lat: 53.5228, lng: -1.1285 },
  rotherham: { lat: 53.4302, lng: -1.3568 },
  barnsley: { lat: 53.5526, lng: -1.4797 },
  wakefield: { lat: 53.6833, lng: -1.4977 },
  huddersfield: { lat: 53.6450, lng: -1.7785 },
  halifax: { lat: 53.7218, lng: -1.8635 },
  harrogate: { lat: 53.9919, lng: -1.5378 },
  lincoln: { lat: 53.2307, lng: -0.5406 },
  chesterfield: { lat: 53.2350, lng: -1.4210 },
  mansfield: { lat: 53.1457, lng: -1.1957 },
  watford: { lat: 51.6565, lng: -0.3903 },
  'st albans': { lat: 51.7550, lng: -0.3360 },
  slough: { lat: 51.5105, lng: -0.5950 },
  guildford: { lat: 51.2362, lng: -0.5704 },
  woking: { lat: 51.3190, lng: -0.5580 },
  crawley: { lat: 51.1091, lng: -0.1872 },
  maidstone: { lat: 51.2720, lng: 0.5290 },
  canterbury: { lat: 51.2802, lng: 1.0789 },
  chelmsford: { lat: 51.7356, lng: 0.4685 },
  colchester: { lat: 51.8959, lng: 0.8919 },
  southend: { lat: 51.5459, lng: 0.7077 },
  'southend-on-sea': { lat: 51.5459, lng: 0.7077 },
  basildon: { lat: 51.5762, lng: 0.4886 },
  croydon: { lat: 51.3762, lng: -0.0982 },
  bromley: { lat: 51.4060, lng: 0.0140 },
  kingston: { lat: 51.4123, lng: -0.3007 },
  romford: { lat: 51.5749, lng: 0.1837 },
  ilford: { lat: 51.5590, lng: 0.0741 },
  enfield: { lat: 51.6521, lng: -0.0807 },
  harrow: { lat: 51.5790, lng: -0.3370 },
  wembley: { lat: 51.5560, lng: -0.2795 },
  watfordshire: { lat: 51.6565, lng: -0.3903 },
  newport: { lat: 51.5842, lng: -2.9977 },
  wrexham: { lat: 53.0430, lng: -2.9925 },
  bangor: { lat: 53.2280, lng: -4.1290 },
  carlisle: { lat: 54.8924, lng: -2.9329 },
  lancaster: { lat: 54.0466, lng: -2.8007 },
  truro: { lat: 50.2632, lng: -5.0510 },
  bognor: { lat: 50.7824, lng: -0.6764 },
  hastings: { lat: 50.8543, lng: 0.5735 },
  eastbourne: { lat: 50.7687, lng: 0.2845 },
  'leamington spa': { lat: 52.2852, lng: -1.5201 },
  warwick: { lat: 52.2823, lng: -1.5849 },
  rugby: { lat: 52.3700, lng: -1.2650 },
  nuneaton: { lat: 52.5230, lng: -1.4680 },
  redditch: { lat: 52.3066, lng: -1.9466 },
  tamworth: { lat: 52.6339, lng: -1.6957 },
  burton: { lat: 52.8030, lng: -1.6420 },
  'burton upon trent': { lat: 52.8030, lng: -1.6420 },
};

/** Look up coordinates for a location name (case/space tolerant). */
export function coordsFor(location) {
  if (!location) return null;
  const key = String(location).trim().toLowerCase();
  if (COORDS[key]) return COORDS[key];
  // try first token (e.g. "Manchester, UK" -> "manchester")
  const first = key.split(/[,(]/)[0].trim();
  if (COORDS[first]) return COORDS[first];
  // try matching any known city contained in the string
  for (const name of Object.keys(COORDS)) {
    if (key.includes(name)) return COORDS[name];
  }
  return null;
}

export default COORDS;
